/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IncentiveCriteriaResponse } from '../models/IncentiveCriteriaResponse';
import type { IncentiveResultResponse } from '../models/IncentiveResultResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class IncentiveRoutesRepository {
  /**
   * Get Incentive Results
   * Get latest incentive result for a job_program.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static incentiveRoutesGetIncentiveResults({
    jobId,
    authorization,
  }: {
    jobId: any,
    authorization?: string,
  }): CancelablePromise<(Array<IncentiveResultResponse> | null)> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/incentive/{job_id}/incentive_result',
      path: {
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Recalculate Incentives
   * Re-calculate incentive results for every program.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static incentiveRoutesRecalculateIncentives({
    jobId,
    authorization,
  }: {
    jobId: any,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/incentive/{job_id}/recalculate_incentives',
      path: {
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Recalculate Jp Incentives
   * Re-calculate incentive results for a specific job program.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static incentiveRoutesRecalculateJpIncentives({
    jobId,
    jobProgramId,
    authorization,
  }: {
    jobId: any,
    jobProgramId: any,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/incentive/{job_id}/recalculate_incentives/{job_program_id}',
      path: {
        'job_id': jobId,
        'job_program_id': jobProgramId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Program Incentive Criteria
   * Get the list of incentive criteria for a given program.
   * @returns IncentiveCriteriaResponse Successful Response
   * @throws ApiError
   */
  public static incentiveRoutesGetProgramIncentiveCriteria({
    jobId,
    jobProgramId,
    authorization,
  }: {
    jobId: any,
    jobProgramId: any,
    authorization?: string,
  }): CancelablePromise<Array<IncentiveCriteriaResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/incentive/{job_id}/incentive_criteria/{job_program_id}',
      path: {
        'job_id': jobId,
        'job_program_id': jobProgramId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
}
